import {Pipe, PipeTransform} from '@angular/core';
import {marked, Renderer} from 'marked';

@Pipe({name: 'emMarkdown'})
export class EmMarkdownPipe implements PipeTransform {
  renderer: Renderer;

  constructor() {
    this.renderer = new marked.Renderer();
    this.configureRenderer();
  }

  transform(value: string): string | Promise<string> {
    return marked(value, {
      breaks: true,
      renderer: this.renderer,
    });
  }

  private configureRenderer(): void {
    this.renderer.listitem = (text: string) => {
      return `<li>${this.formatText(text)}</li>`;
    };

    this.renderer.paragraph = (text: string) => {
      return `<p>${this.formatText(text)}</p>`;
    };
  }

  private formatText(text: string): string {
    // Handle highlighting pattern
    text = text.replace(/==([^=]+)==/g, (_, p1) => `<span class='highlight'>${p1}</span>`);

    // Handle bold pattern
    const boldPattern = /\*\*(.*?)\*\*/g;
    text = text.replace(boldPattern, (_, p1) => `<strong>${p1}</strong>`);

    // Handle italic pattern
    const italicPattern = /\*(.*?)\*/g;
    text = text.replace(italicPattern, (_, p1) => `<em>${p1}</em>`);

    // Handle underlining pattern
    const underlinePattern = /\+\+(.*?)\+\+/g;
    text = text.replace(underlinePattern, (_, p1) => `<u>${p1}</u>`);

    return text;
  }
}
